import { useState, forwardRef } from "react";

import Button from "@mui/material/Button";
import {
  GridToolbarContainer,
  GridToolbarContainerProps,
  GridAddIcon,
} from "@mui/x-data-grid";
import AddExcludeUser from "./AddExcludeUser";
import type { UserInfo } from "../../utils/api";

export interface GridToolbarProps {
  onUpdateRows: (data: UserInfo) => void;
}

const GridToolbar = forwardRef<
  HTMLDivElement,
  GridToolbarContainerProps & GridToolbarProps
>(function GridToolbar(props: GridToolbarProps, ref) {
  const { onUpdateRows, ...other } = props;
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (data?: UserInfo) => {
    setOpen(false);
    if (data) {
      onUpdateRows(data);
    }
  };

  return (
    <GridToolbarContainer ref={ref} {...other}>
      <Button
        color="primary"
        size="small"
        startIcon={<GridAddIcon />}
        onClick={handleOpen}
      >
        Add User
      </Button>
      <AddExcludeUser open={open} onClose={handleClose} />
    </GridToolbarContainer>
  );
});
export default GridToolbar;
